var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 8.43747C7.18258 8.43747 6.24984 9.34689 6.24984 10.4687C6.24984 11.5905 7.18258 12.5 8.33317 12.5C9.48376 12.5 10.4165 11.5905 10.4165 10.4687C10.4165 9.34689 9.48376 8.43747 8.33317 8.43747Z",
    fill: "#111D5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 8.43747C13.8492 8.43747 12.9165 9.34689 12.9165 10.4687C12.9165 11.5905 13.8492 12.5 14.9998 12.5C16.1504 12.5 17.0832 11.5905 17.0832 10.4687C17.0832 9.34689 16.1504 8.43747 14.9998 8.43747Z",
    fill: "#111D5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5832 10.4687C19.5832 9.34689 20.5159 8.43747 21.6665 8.43747C22.8171 8.43747 23.7498 9.34689 23.7498 10.4687C23.7498 11.5905 22.8171 12.5 21.6665 12.5C20.5159 12.5 19.5832 11.5905 19.5832 10.4687Z",
    fill: "#111D5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8344 0.463256C17.3441 0.0898964 12.8303 0.0682289 8.33641 0.398462L8.01435 0.422128C3.72885 0.73705 0.416504 4.21915 0.416504 8.40937V22.25C0.416504 22.6788 0.647614 23.076 1.02508 23.296C1.40256 23.5161 1.87085 23.5265 2.25823 23.3235L8.77622 19.9082C9.07941 19.7494 9.41824 19.6662 9.76243 19.6662H24.7231C26.6099 19.6662 28.2269 18.351 28.5651 16.5411C29.2506 12.8731 29.3047 9.11941 28.7254 5.43406L28.5546 4.34803C28.2438 2.37081 26.5848 0.858241 24.5406 0.688272L21.8344 0.463256ZM8.5243 2.82907C12.8849 2.50863 17.2648 2.52965 21.622 2.89194L24.3282 3.11696C25.2221 3.19128 25.9475 3.85272 26.0835 4.71735L26.2542 5.80338C26.7915 9.22121 26.7413 12.7024 26.1056 16.1042C25.9839 16.7554 25.4021 17.2287 24.7231 17.2287H9.76243C9.0052 17.2287 8.25977 17.4116 7.59276 17.7611L2.9165 20.2114V8.40937C2.9165 5.49428 5.22086 3.07182 8.20225 2.85273L8.5243 2.82907Z",
    fill: "#111D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatActive);
export default __webpack_public_path__ + "static/media/Chat_Active.e897888125bec84a8a4914b503d3b4c0.svg";
export { ForwardRef as ReactComponent };